// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__38G0_","icon":"SortAdornment_icon__1XsO3","up":"SortAdornment_up__sIKGa","down":"SortAdornment_down__1Dgca","active":"SortAdornment_active__2ANy4"};